goog.provide("shadow.js.shim.module$react_bootstrap$Tab$default");
shadow.js.shim.module$react_bootstrap$Tab$default = shadow.js.require(372, {}).default;
